import { PlanType } from './plan-type'
import { SERVICE_PLAN_STEP_DEFINITIONS } from './service-plan-step-definition'
import { ServicePlanStepId } from './service-plan-step-id'

// Pure implementation of ServicePlan-GuidedFormDesign.md Section 2's plan-type
// branching matrix (rules 1, 2, 5, 6 in Section 5). See story e8-1 AC6 for the
// four expected step lists this is tested against verbatim.
export function getVisibleSteps(
  planType: PlanType,
  hasNdis: boolean,
): ServicePlanStepId[] {
  return SERVICE_PLAN_STEP_DEFINITIONS.filter((definition) =>
    definition.visibleForPlanTypes.includes(planType),
  )
    .filter((definition) => definition.id !== 'ndisClassification' || hasNdis)
    .map((definition) => definition.id)
}
